import { Shape } from "types/shape";

export const getUniqueContributorsAvatarURL = (shapes: Shape[] | undefined) => {
  const contributorsAvatar =
    shapes.length > 0
      ? shapes?.map((shape: Shape) => shape.users?.avatar_url)
      : [""];

  const contributorsAvatarSet = new Set(contributorsAvatar);

  return [...contributorsAvatarSet];
};
